import { TasksViewOptions } from "../../../tasks/components/TasksViewSelect"
import { TaskColumnName } from "../../../treegrid/task-list/types"

export const taskListDefaultColumnOrderByView: Record<TasksViewOptions, TaskColumnName[]> = {
  currentAndFuture: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
    "actualBarStartDate",
    "actualBarEndDate",
    "ganttGanttHtmlRight",
    "ganttRun",
  ],
  all: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "rejectedDate",
    "status",
    "completionPercentage",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
    "actualBarStartDate",
    "actualBarEndDate",
    "ganttGanttHtmlRight",
    "ganttRun",
  ],
  completed: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
  archived: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "participants",
    "suppliers",
    "workspaces",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
  rejected: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "participants",
    "suppliers",
    "workspaces",
    "actualStartDate",
    "actualEndDate",
    "rejectedDate",
    "status",
    "completionPercentage",
    "state",
    "statusDescription",
    "description",
    "linksAndAttachments",
    "ganttBarColor",
  ],
}

// This list also needs to be ordered according to how the columns should be ordered in the UI
export const taskListDefaultVisibleColumnsByView: Record<TasksViewOptions, TaskColumnName[]> = {
  currentAndFuture: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "status",
    "completionPercentage",
    "statusDescription",
  ],
  all: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "completionPercentage",
    "statusDescription",
  ],
  completed: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "actualEndDate",
    "statusDescription",
    "description",
  ],
  archived: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "plannedStartDate",
    "plannedEndDate",
    "actualStartDate",
    "actualEndDate",
    "status",
    "statusDescription",
    "description",
  ],
  rejected: [
    "open",
    "customers",
    "taskNumber",
    "title",
    "managers",
    "rejectedDate",
    "statusDescription",
    "description",
  ],
}
